/**
 * Shallow replacement for lodash `omit` - lodash's version pulls its whole deep-clone code
 * into the main bundle, while we only ever omit top-level keys
 */
export const omit = <T extends object, K extends PropertyKey>(
  object: T | null | undefined,
  keys: K | readonly K[]
): Omit<T, K> => {
  const keysToOmit = new Set<PropertyKey>(([] as PropertyKey[]).concat(keys));

  return Object.fromEntries(
    Object.entries(object ?? {}).filter(([key]) => !keysToOmit.has(key))
  ) as Omit<T, K>;
};
